module.exports = __webpack_public_path__ + "img/color-dynamics-1_cn.4f57739.jpg";